"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M21.5 17.026V5.974C21.5 4.884 20.567 4 19.417 4H3.583C2.433 4 1.5 4.884 1.5 5.974v11.052c0 1.09.933 1.974 2.083 1.974h15.834c1.15 0 2.083-.884 2.083-1.974zM2.333 11.5c0-.655.559-1.184 1.25-1.184.692 0 1.25.529 1.25 1.184 0 .655-.558 1.184-1.25 1.184-.691 0-1.25-.529-1.25-1.184zm3.334 5.921V5.58H19V17.42H5.667z" }), "ResolutionMediumLandscape");
//# sourceMappingURL=ResolutionMediumLandscape.js.map